export default __webpack_public_path__ + "static/media/followUps.29da6440.svg";